var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('div',{staticStyle:{"display":"inline"}},[_c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2)],1):_c('div',{staticStyle:{"display":"inline"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }